var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "../../services/FetchService";
function getResourceVisibilityOptions() {
    return FetchService.getSingleResponse("/aviso/resource/getResourceVisibilities");
}
const resourceTypeOptions = [
    { id: 1, description: "Use content from the editor below" },
    { id: 2, description: "Use content from a url" },
];
export default class ResourceForm {
    static getResourceForm() {
        return __awaiter(this, void 0, void 0, function* () {
            const resourceVisibilityOptions = yield getResourceVisibilityOptions();
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            if (resourceVisibilityOptions.length < 1) {
                return [];
            }
            return [
                [
                    {
                        property: "name",
                        label: "Title",
                        placeholder: "",
                        defaultValue: "",
                        type: "text",
                        helpText: "This is the title by which the resource is displayed.",
                        value: "",
                        isRequired: true,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => !!v.trim() && v.trim().length < 256,
                        errorMessage: "Name should be no longer than 255 characters",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "resourceVisibility",
                        label: "Visibility",
                        placeholder: "",
                        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                        defaultValue: resourceVisibilityOptions[0],
                        type: "radioGroup",
                        options: resourceVisibilityOptions,
                        helpText: "Note: Sharing a resource will allow visibility for that resource to that user.",
                        value: "",
                        isRequired: true,
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "active",
                        label: "Active",
                        placeholder: "",
                        defaultValue: false,
                        type: "checkbox",
                        helpText: "When a resource is active it will be viewable by others.",
                        value: "",
                        isRequired: false,
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "commentsEnabled",
                        label: "Enable Reviews",
                        placeholder: "",
                        defaultValue: false,
                        type: "checkbox",
                        helpText: "Allow users to rate and leave comments on this resource.",
                        value: "",
                        isRequired: false,
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "summary",
                        label: "Summary",
                        placeholder: "",
                        defaultValue: "",
                        type: "textarea",
                        rows: 5,
                        helpText: "This is the summary displayed in the list for this resource. This should also include any key words you would like this resource to be searchable by.",
                        value: "",
                        isRequired: true,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => !!v.trim() && v.trim().length < 4001,
                        errorMessage: "Summary should be no longer than 4000 characters",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "address",
                        label: "Address",
                        placeholder: "",
                        defaultValue: {
                            value: "abc",
                            address: {},
                        },
                        className: "",
                        type: "googleAddress",
                        helpText: "",
                        value: {
                            value: "abc",
                            address: {},
                        },
                        isRequired: false,
                        types: ["address"],
                        componentRestrictions: { country: "us" },
                        // @ts-expect-error - TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => !v.value || v.value.trim().length < 100,
                        errorMessage: "Address is too long",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "primaryContactName",
                        label: "Primary Contact Name",
                        placeholder: "",
                        defaultValue: "",
                        className: "col-6",
                        type: "text",
                        helpText: "",
                        value: "",
                        isRequired: false,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => v.trim().length < 255,
                        errorMessage: "Name is too long",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                    {
                        property: "primaryContactEmail",
                        label: "Primary Contact Email",
                        placeholder: "",
                        defaultValue: "",
                        className: "col-6",
                        type: "text",
                        helpText: "",
                        value: "",
                        isRequired: false,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => v.trim().length < 255,
                        errorMessage: "Email is too long",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "phoneNumber",
                        label: "Contact Phone Number",
                        placeholder: "",
                        defaultValue: "",
                        className: "col-8",
                        type: "text",
                        helpText: "",
                        value: "",
                        isRequired: false,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => !v.trim().length || (v.trim().length < 12 && /[^d]/.test(v)),
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type.
                        onValueChange: (v) => v.replace(/\D/g, ""),
                        errorMessage: "Invalid Phone Number",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                    {
                        property: "phoneExtension",
                        label: "Contact Extension",
                        placeholder: "",
                        defaultValue: "",
                        className: "col-4",
                        type: "text",
                        helpText: "",
                        value: "",
                        isRequired: false,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => v.trim().length < 11,
                        errorMessage: "Extension is too long",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "url",
                        label: "Website",
                        placeholder: "",
                        defaultValue: "",
                        className: "",
                        type: "text",
                        helpText: "The url must have either http:// or https:// prepended to the url to work successfully.",
                        value: "",
                        isRequired: false,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => {
                            let urlValid = true;
                            if (v) {
                                const regex = new RegExp("^(http|https)://", "i");
                                urlValid = regex.test(v);
                            }
                            return urlValid && v.trim().length < 255;
                        },
                        errorMessage: "URL must be less than 255 characters and must start with either http:// or https://",
                        shouldShow: (formState, currentTab) => currentTab === 1,
                    },
                ],
                [
                    {
                        property: "displayInternalResource",
                        label: "Content Options",
                        placeholder: "",
                        defaultValue: resourceTypeOptions[0],
                        type: "radioGroup",
                        options: resourceTypeOptions,
                        helpText: "",
                        value: "",
                        isRequired: true,
                        shouldShow: (formState, currentTab) => currentTab === 2,
                    },
                ],
                [
                    {
                        property: "description",
                        label: "Description",
                        placeholder: "",
                        defaultValue: "",
                        type: "tinymce",
                        rows: 25,
                        height: 500,
                        helpText: "This is the content that will be shown on the resources details page. Feel free to use HTML.",
                        value: "",
                        isRequired: false,
                        shouldShow: (formState, currentTab) => currentTab === 2 && formState.displayInternalResource.id === 1,
                    },
                ],
                [
                    {
                        property: "externalResourceUrl",
                        label: "Url",
                        placeholder: "",
                        defaultValue: "",
                        className: "",
                        type: "text",
                        helpText: "The url must have either http:// or https:// prepended to the url to work successfully.",
                        value: "",
                        isRequired: false,
                        // @ts-expect-error - TS7006 - Parameter 'v' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
                        isValid: (v, i) => {
                            let urlValid = true;
                            if (v) {
                                const regex = new RegExp("^(http|https)://", "i");
                                urlValid = regex.test(v);
                            }
                            return urlValid && v.trim().length < 255;
                        },
                        errorMessage: "URL must be less than 255 characters and must start with either http:// or https://",
                        shouldShow: (formState, currentTab) => currentTab === 2 && formState.displayInternalResource.id === 2,
                    },
                ],
            ];
        });
    }
}
